(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initShoppableCardLoading(form) {
      if (!form) return;

      var button = form.querySelector('.shoppable-card__product-add');
      if (!button) return;

      var icon = button.querySelector('.shoppable-card__product-add-icon');
      var spinner = button.querySelector('.shoppable-card__product-add-spinner');

      form.addEventListener('submit', function() {
        if (!button || button.getAttribute('aria-busy') === 'true') return;

        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        if (icon) icon.hidden = true;
        if (spinner) spinner.hidden = false;
      });
    }

    document.querySelectorAll('.shoppable-card__form').forEach(function(form) {
      initShoppableCardLoading(form);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
